var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-white rounded-lg",staticStyle:{"height":"1400px"}},[_c('DataTable'),_c('div',{staticStyle:{"height":"60px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }